export interface ImagePalette { background:string; surface:string; muted:string; border:string; primary:string; foreground:string; mutedForeground:string }
const clamp = (n:number,min:number,max:number) => Math.max(min,Math.min(max,n));
function toHsl(r:number,g:number,b:number) {
  r/=255;g/=255;b/=255; const max=Math.max(r,g,b),min=Math.min(r,g,b),d=max-min,l=(max+min)/2;
  const s=d === 0 ? 0 : d/(1-Math.abs(2*l-1));
  const h=d === 0 ? 0 : (max === r ? ((g-b)/d+6)%6 : max === g ? (b-r)/d+2 : (r-g)/d+4)*60;
  return {h,s,l};
}
export function hslHex(h:number,s:number,l:number):string {
  const a=s*Math.min(l,1-l),f=(n:number)=>{const k=(n+h/30)%12;return l-a*Math.max(-1,Math.min(k-3,9-k,1));};
  return '#'+[0,8,4].map(n=>Math.round(f(n)*255).toString(16).padStart(2,'0')).join('');
}
/** Dominant hue buckets prevent pale highlights and dark shadows washing out the palette. */
export function paletteFromPixels(pixels:ArrayLike<number>):ImagePalette | null {
  const bins = Array.from({length:13},()=>({weight:0,r:0,g:0,b:0}));
  for(let i=0;i+3<pixels.length;i+=4){
    const alpha=pixels[i+3]!/255;if(alpha<.1)continue;
    const r=pixels[i]!,g=pixels[i+1]!,b=pixels[i+2]!,{h,s,l}=toHsl(r,g,b);
    const weight=alpha*(.2+s)*(l<.06 || l>.96 ? .08 : 1);
    const bin=bins[s<.07?12:Math.floor(h/30)%12]!;bin.weight+=weight;bin.r+=r*weight;bin.g+=g*weight;bin.b+=b*weight;
  }
  const bin=bins.reduce((a,b)=>a.weight>=b.weight?a:b);if(!bin.weight)return null;
  const {h,s,l}=toHsl(bin.r/bin.weight,bin.g/bin.weight,bin.b/bin.weight);
  const saturation=s<.07?0:clamp(s,.2,.48),base=clamp(.16+l*.09,.17,.24);
  return {background:hslHex(h,saturation,base),surface:hslHex(h,saturation*.8,base+.065),muted:hslHex(h,saturation*.65,base+.105),border:hslHex(h,saturation*.45,base+.22),primary:hslHex(h,saturation*.65,.79),foreground:hslHex(h,saturation*.22,.96),mutedForeground:hslHex(h,saturation*.3,.78)};
}
